import { StringHelpers } from "../helpers/string-helpers";
import { IChartContainer } from "../models/base/chart-container.interface";
import { TIChartPointModel } from "../models/data-point/ti-chart-point.model";
import { LimitAlertImageModel } from "../models/limit-alert/limit-alert-image.model";
import { IComponent } from "./component.interface";

export class DrawLimitAlertsImageComponent implements IComponent {
    public id = '';

    private base: IChartContainer;
    private model: LimitAlertImageModel | null = null;

    constructor(base: IChartContainer) {
        this.id = StringHelpers.newGuid();
        this.base = base;
        this.base.tiChartSeries?.subscribeExtremeChange(() => {
            setTimeout(() => {
                this.draw();
            }, 50);
        });  
        this.base.tiChartSeries?.subscribeRedrawChange(() => {
            setTimeout(() => {
                this.draw();
            }, 50);
        });
        this.subscribe();
    }

    public remove() {
        const highchartContainer = this.base.tiChartSeries.element.findFirst('.highcharts-container');
        if (!highchartContainer) {
            return;
        }

        const previousElement = highchartContainer.findFirst('.draw-limit-alerts-image');
        previousElement?.remove();
    }

    private subscribe() {
        this.base.chartService.subscribePriceAlertsImageData((model: LimitAlertImageModel) => {
            this.model = model;
            console.log('subscribe DrawLimitAlertsImageComponent ', this.model)
            this.draw();
        });
    }

    // private isDraw = false;
    private draw() {
        this.remove();

        const highchartContainer = this.base.tiChartSeries.element.findFirst('.highcharts-container');
        if (!highchartContainer) {
            return;
        }

        // console.log('draw DrawLimitAlertsImageComponent ', this.model)
        // if (this.isDraw) {return;}

        // const previousElement = highchartContainer.findFirst('.draw-limit-alerts-image');
        // previousElement?.remove();

        const wrapperDiv = document.createElement('div');
        wrapperDiv.classList.add('draw-limit-alerts-image');
        
        if (!this.base.tiChartSeries || !this.model || this.model.xValue == null) {
            return;
        }
        
        
        const xValue = Math.round(this.model.xValue);
        const mainChartSerie: any = this.base.tiChartSeries.highStockChart.series[0];
        const yAxis = this.base.tiChartSeries.highStockChart.yAxis[0];
        const xAxis = this.base.tiChartSeries.highStockChart.xAxis[0];
        const dataPoint = this.base.tiChartSeries.tiChartPoints.find((x: TIChartPointModel) => x.xValue == xValue);
        if (!mainChartSerie || !yAxis || !xAxis || !mainChartSerie.processedXData.some((x: number) => x == xValue) || !dataPoint) {
            return;
        }

        const image = this.model.getImage(this.base.basePath);

        let top = this.base.tiChartSeries?.hasAnyComparisonSymbols() ? 53 : 33;
        let left = 0;

        if (this.model.up) {
            top += yAxis?.toPixels(dataPoint.low, true) + 18;
        } else {
            top += yAxis?.toPixels(dataPoint.high, true) - 8;
        }

        left = xAxis?.toPixels(xValue, false) - 9;

        const div = `<div class="dla dla-${this.id}" style="position:absolute;top:${top.toFixed(2)}px; left:${left.toFixed(2)}px;" title="${this.model.tooltip}">
            <img src="${image}" alt="image" />
        </div>`;
        
        wrapperDiv.insertAdjacentHTML('beforeend', div);
        highchartContainer.insertAdjacentElement('beforeend', wrapperDiv);
        // this.isDraw = true;
    }
}